export const SET_TAP_TO_PAY_TIPS = 'SET_TAP_TO_PAY_TIPS'
